// extracted by mini-css-extract-plugin
export var active = "index-module--active--vDRtV";
export var personImageContainer = "index-module--personImageContainer--6cYiT";